[
  { "code": "1", "name": "No illness" },
  { "code": "2", "name": "Startup problems" },
  { "code": "3", "name": "Respiratory disorder" },
  { "code": "4", "name": "Gastrointestinal disorder" },
  { "code": "5", "name": "Disorder of musculoskeletal system" },
  { "code": "6", "name": "Various infections" },
  { "code": "7", "name": "Yolk rest infection" },
  { "code": "8", "name": "Colibacillosis" },
  { "code": "9", "name": "Bacterial infection" },
  { "code": "10", "name": "Coccidiosis" },
  { "code": "11", "name": "Necrotic enteritis" },
  { "code": "12", "name": "Enteritis" },
  { "code": "13", "name": "Clostridium infection" },
  { "code": "14", "name": "Mycoplasma infection" },
  { "code": "15", "name": "Respiratory infection" },
  { "code": "16", "name": "Air sac infection" },
  { "code": "17", "name": "Intestinal inflammation" },
  { "code": "18", "name": "Coli infection" },
  { "code": "19", "name": "Other" },
  { "code": "20", "name": "Head cold" },
  { "code": "21", "name": "Joint inflammation" }
]
